import { logError } from "@/lib/error-handling";
import type { CreateActivityContactSchemaType } from "@/schemas/contactSchema";
import type { UpdateRecapEmailSchemaType } from "@/schemas/recapEmailSchema";
import { apiClient } from "@/services/api";
import type { CallOutputDto, ContactDto, RecapEmailEditDto } from "@/types";

export async function fetchCallOutput(
  activityId: string
): Promise<CallOutputDto> {
  try {
    return await apiClient<CallOutputDto>(
      `/api/activities/${activityId}/call-output`,
      { method: "GET", cache: "no-store" }
    );
  } catch (error) {
    logError(error, "fetchCallOutput");
    throw error;
  }
}

export async function createContactForActivity(
  activityId: string,
  data: CreateActivityContactSchemaType
): Promise<ContactDto> {
  try {
    return await apiClient<ContactDto>(
      `/api/activities/${activityId}/contacts`,
      { method: "POST", body: JSON.stringify(data) }
    );
  } catch (error) {
    logError(error, "createContactForActivity");
    throw error;
  }
}

export async function updateRecapEmail(
  activityId: string,
  data: UpdateRecapEmailSchemaType
): Promise<RecapEmailEditDto> {
  try {
    return await apiClient<RecapEmailEditDto>(
      `/api/activities/${activityId}/recap-email`,
      { method: "PATCH", body: JSON.stringify(data) }
    );
  } catch (error) {
    logError(error, "updateRecapEmail");
    throw error;
  }
}
